/**
 * Espelha StatusOrdemProducaoEnum da API.Suprimentos e a tabela status_ordem_producao.
 */
export enum StatusOrdemProducaoEnum {
  EmAberto = 1,
  EmAndamento = 2,
  Finalizada = 3,
  Cancelada = 4,
}

/** Rótulo e cor de badge por status, seguindo as classes globais do styles.css. */
export const StatusOrdemProducaoDescricao: { [key: number]: string } = {
  [StatusOrdemProducaoEnum.EmAberto]: 'Em aberto',
  [StatusOrdemProducaoEnum.EmAndamento]: 'Em andamento',
  [StatusOrdemProducaoEnum.Finalizada]: 'Finalizada',
  [StatusOrdemProducaoEnum.Cancelada]: 'Cancelada',
};

export const StatusOrdemProducaoBadge: { [key: number]: string } = {
  [StatusOrdemProducaoEnum.EmAberto]: 'badge-azul',
  [StatusOrdemProducaoEnum.EmAndamento]: 'badge-amarelo',
  [StatusOrdemProducaoEnum.Finalizada]: 'badge-verde',
  [StatusOrdemProducaoEnum.Cancelada]: 'badge-vermelho',
};
